import uniqid from 'uniqid'
import filter from 'lodash/fp/filter'
import without from 'lodash/fp/without'
import isObject from 'lodash/fp/isObject'

import { isApiError } from '../apis'

export const ERROR_CODES = {
  AUTH_FAILED: 'AuthError'
}

const HTTP_STATUS_MESSAGES: Record<number, string> = {
  401: 'You are not authorized to perform this action.',
  403: 'You do not have permission to perform this action.',
  404: 'The requested item could not be found.',
  500: 'Something went wrong on the server. Please try again.'
}

const SESSION_EXPIRED_MESSAGE =
  'Your session is no longer valid. Please sign in again.'

const getErrorMessage = error => {
  if (!isObject(error)) return error

  if (isApiError(error)) {
    if (error.isSessionExpired) return SESSION_EXPIRED_MESSAGE

    if (!error.hasServerMessage) {
      const status = Number(error.httpStatus)

      return (
        HTTP_STATUS_MESSAGES[status] ||
        `The request failed (${status || 'unknown error'}).`
      )
    }
  }

  return (error as Error).message
}

export const getAuthErrors = filter({ name: ERROR_CODES.AUTH_FAILED })

export const getNotAuthErrors = without({ name: ERROR_CODES.AUTH_FAILED })

export const parseError = (error, custom = {}) => ({
  // @ts-ignore
  id: custom.id || uniqid.time(),
  // @ts-ignore
  name: custom.name || (isObject(error) ? error.name : ''),
  message: getErrorMessage(error),
  isApiError: isApiError(error),
  isSessionExpired: isApiError(error) && !!error.isSessionExpired,
  source: error,
  timestamp: Date.now()
})

export const isSessionExpiredError = (error: any) => !!error?.isSessionExpired
